module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image1-d3b0a7f1fe7d3a9e6c5a22e4d7a4f2b9.jpg";